import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { getProductName } from '../../utilities/productColor';

function PopUP(props) {
  const productName = props.category === "adalimumab" ? "Adalimumab-aaty" : 
                      props.category === "yuflyma" ? "Yuflyma" : 
                      props.category === "vegzelma" ? "Vegzelma" : 
                      props.category === "zymfentra" ? "Zymfentra" : 
                      props.category === "steqeyma" ? "Steqeyma" : 
                      props.category === "osenvelt" ? "Osenvelt" : 
                      props.category === "stoboclo" ? "Stoboclo" :
                      props.category === "avtozma" ? "Avtozma" :
                      props.category === "omlyclo" ? "Omlyclo" : "";
  const isPaySign = props.category === "zymfentra" || props.category === "steqeyma"|| props.category === "osenvelt" || props.category === "stoboclo"|| props.category === "avtozma" || props.category === "omlyclo" || props.category === "vegzelma" ? true : false; 
   
  const product = getProductName(props.category).toLocaleLowerCase();

  return (
    <>

        <Modal
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className={`popup ${product}-modal-content`}
        >
          {isPaySign && 
            <Modal.Body className="popup-padding">
                    <p className="p-content">
                    Thank you for your interest in the<br />Celltrion CARES<sup className="reg">&reg;</sup> Co-pay Assistance Program.
                    </p>
                    <p className="p-content">This program is offered by Celltrion USA to provide {productName.toUpperCase()}<sup className="reg">&reg;</sup> for eligible patients. <br />We have reviewed the application and determined that the 
                    patient is not eligible to participate in the Celltrion CARES Co-pay Assistance Program.
                    </p>
                    <p className="p-content">If the patient’s situation changes, please notify the
                    Celltrion CARES Co-pay Assistance Program, and
                    we will be pleased to reassess the request.
                    </p>
                    <p className="p-content">
                      If you have any questions and would like to further discuss
                      this decision, please don’t hesitate to contact us at 1-877-812-6662,<br /> 
                      Monday-Friday, 8 <span style={{ fontSize: "0.8em", textTransform: "uppercase" }}>AM</span> - 8 <span style={{ fontSize: "0.8em", textTransform: "uppercase" }}>PM</span> ET.
                    </p>

            </Modal.Body>
          } 
           {!isPaySign && 
          <Modal.Body className="popup-padding">
            <p>
              Thank you for your interest in the Celltrion CARES<sup className="reg">&reg;</sup>{" "}
              Co-pay Assistance Program.
            </p>
            <p>
              This program is offered by Celltrion USA to provide {productName}
              {props.category === "adalimumab" ? "" : props.category === "zymfentra" ? <><sup className="reg">&trade;</sup></> : <><sup className="reg">&reg;</sup></>} {" "}
              for eligible patients. We have reviewed the application and
              determined that the patient is not eligible to participate in the
              Celltrion CARES<sup>&reg;</sup> Co-pay Assistance Program.
            </p>
            <p>
              If the patient's situation changes, please notify the Celltrion CARES<sup>&reg;</sup> Co-pay
              Assistance Program and we will be pleased to reassess the request.
            </p>
            <p>
              If you have any questions and would like to further discuss this
              decision, please don’t hesitate to contact us at 1-877-812-6662, 8 <span style={{ fontSize: "0.8em", textTransform: "uppercase" }}>AM</span> - 8 <span style={{ fontSize: "0.8em", textTransform: "uppercase" }}>PM</span> ET, Monday - Friday.
            </p>
          </Modal.Body>
          }
          <Modal.Footer className="popup-footer">
            <Button className={`${product}-btn-filled`} onClick={props.onHide}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      
    </>
  );
}
export default PopUP;